// src/redux/slices/products.slice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Product } from '../../types/product.types';

interface ProductsState {
  modalOpen: boolean;
  selectedProduct: Product | null;
  loading: boolean;
  error: string | null;
}

const initialState: ProductsState = {
  modalOpen: false,
  selectedProduct: null,
  loading: false,
  error: null,
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<Product | null>) => {
      state.modalOpen = true;
      state.selectedProduct = action.payload;
    },
    closeModal: (state) => {
      state.modalOpen = false;
      state.selectedProduct = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { openModal, closeModal, setLoading, setError } = productsSlice.actions;
export default productsSlice.reducer;
